// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

function initializeSwiper() {

	const swiperInstances = document.querySelectorAll('.swiper');

	swiperInstances.forEach((swiperInstance) => {

		const dataAutoplay = swiperInstance.getAttribute('data-autoplay');
		const dataSlideDelayAttributeValue = swiperInstance.getAttribute('data-slideDelay');
		const dataSlideDelay = parseInt(dataSlideDelayAttributeValue);

		// Set options as var
		let options = {
			// configure Swiper to use modules
			modules: [Navigation, Pagination, Autoplay],

			speed: 700,

			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			}
		}


		// Check to see if options value is set and then append option and properties to options var above
		if (dataAutoplay == "True") {
			options.autoplay = {
				delay: dataSlideDelay
			}
		}

		// init Swiper:
		new Swiper(swiperInstance, options);

	});
};


export {
	initializeSwiper
}
